import { Separator } from "@/components/ui/separator";
import { CartCard } from "../CartCard";
import type { CartItem } from "../../store/useCartStore";

interface CartItemsListProps {
  items: CartItem[];
  onRemoveItem: (itemId: string) => void;
}

/**
 * CartItemsList Component
 * Renders list of cart items with separators between each item
 */
export function CartItemsList({ items, onRemoveItem }: CartItemsListProps) {
  return (
    <>
      {items.map((item, index) => (
        <div key={item.id}>
          <CartCard item={item} onRemove={onRemoveItem} />
          {/* Always add separator after each CartCard except the last one */}
          {index < items.length - 1 && <Separator />}
        </div>
      ))}
    </>
  );
}
